/* @jsx h */
import { defineComponent, h } from "vue";
import { LemmonModal, useLocalization } from "@lemmonhq/uikit";

interface QRScannerModalProps {
  onClose: () => void;
  onScan: (url: string) => void;
}

export const QRScannerModal = defineComponent<QRScannerModalProps>({
  name: "QRScannerModal",
  props: ["onClose", "onScan"],
  setup(props) {
    const { t } = useLocalization();
    return () => (
      <LemmonModal
        title={t("customer.shop_home.join_your_table")}
        onClose={props.onClose}
      >
        <div class="space-y-8 p-4">
          {/* Main Instruction Section */}
          <div class="text-center space-y-6">
            {/* QR Code Icon */}
            <div class="mx-auto w-24 h-24 bg-gradient-to-br from-blue-500 to-purple-600 rounded-2xl flex items-center justify-center shadow-lg">
              <span class="material-symbols-outlined text-white text-4xl">
                qr_code_scanner
              </span>
            </div>

            {/* Title and Description */}
            <div class="space-y-3">
              <h2 class="text-2xl font-bold text-gray-800">
                {t("customer.shop_home.scan_table_qr")}
              </h2>
              <p class="text-gray-600 max-w-md mx-auto leading-relaxed">
                {t("customer.shop_home.scan_table_qr_copy")}
              </p>
            </div>

            {/* Step-by-step Instructions */}
            <div class="bg-gradient-to-r from-blue-50 to-purple-50 rounded-2xl p-6 max-w-md mx-auto">
              <div class="space-y-4">
                <div class="flex items-center gap-3 text-left">
                  <div class="w-8 h-8 bg-blue-500 text-white rounded-full flex items-center justify-center text-sm font-bold">
                    1
                  </div>
                  <p class="text-sm text-gray-700">
                    {t("customer.shop_home.open_camera_app")}
                  </p>
                </div>
                <div class="flex items-center gap-3 text-left">
                  <div class="w-8 h-8 bg-purple-500 text-white rounded-full flex items-center justify-center text-sm font-bold">
                    2
                  </div>
                  <p class="text-sm text-gray-700">
                    {t("customer.shop_home.point_camera_at_qr")}
                  </p>
                </div>
                <div class="flex items-center gap-3 text-left">
                  <div class="w-8 h-8 bg-green-500 text-white rounded-full flex items-center justify-center text-sm font-bold">
                    3
                  </div>
                  <p class="text-sm text-gray-700">
                    {t("customer.shop_home.tap_link")}
                  </p>
                </div>
              </div>
            </div>

            {/* Visual QR Code Mockup */}
            <div class="max-w-xs mx-auto hidden">
              <div class="bg-white rounded-xl shadow-lg p-4 border border-gray-200">
                <div class="aspect-square bg-gray-100 rounded-lg flex items-center justify-center">
                  <div class="grid grid-cols-8 gap-1 p-4">
                    {Array.from({ length: 64 }).map((_, i) => (
                      <div
                        key={i}
                        class={`w-2 h-2 ${
                          Math.random() > 0.5 ? "bg-black" : "bg-white"
                        } rounded-sm`}
                      />
                    ))}
                  </div>
                </div>
                <p class="text-xs text-gray-500 mt-2 text-center">
                  {t("customer.shop_home.scan_me")}
                </p>
              </div>
            </div>
          </div>
        </div>
      </LemmonModal>
    );
  },
});
